import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';
const compareObjects = require('fast-deep-equal');

import { IParameterFieldBaseOptions } from '../ts/ParameterFieldBase';
import { getCSSWidth } from '../ts/Utilities';

interface IRadioGroupFieldState {
    value: any;
    radioGroupName: string;
}

export type HorizontalOverflowType = 'hidden' | 'wrap';
export type RadioGroupFieldLayoutType = 'horizontal' | 'vertical' | string;

export interface IRadioGroupFieldItem {
    text: string;
    value: any;
    content?: React.JSX.Element;
    disabled?: boolean;
    className?: string;
}

export interface IRadioGroupFieldOptions extends IParameterFieldBaseOptions {
    title?: string;
    name?: string;
    layout?: RadioGroupFieldLayoutType;
    horizontalOverflow?: HorizontalOverflowType;
    items?: IRadioGroupFieldItem[];
    displayField?: string; //    default "text"
    valueField?: string; //    default "value"
    useInitialValue?: boolean; //LL: 18.12.19:  RadioGroup is Uncontrolled Component, defaultChecked={ checked } is used
}

let ID = 0;

export default class RadioGroupFieldComponent extends React.Component<
    {
        value?: any;
        title?: string;
        items?: IRadioGroupFieldItem[];
        layout?: RadioGroupFieldLayoutType;
        options?: IRadioGroupFieldOptions;
        disabled?: boolean;
        //readOnly?: boolean;

        onChange?(value: any): void;
    },
    IRadioGroupFieldState
> {
    constructor(props) {
        super(props);

        const value = this.props.value;

        this.state = {
            value: value,
            //EVG: Each Radio Group must have unique name for not being considered the same.
            radioGroupName: 'radioGroup_' + ++ID
        };
    }

    componentWillReceiveProps(newProps) {
        const newValue = newProps.value;

        if (newValue !== this.state.value) {
            this.setState({ value: newValue });
        }
    }

    getItems = () => {
        if (this.props.items != null) {
            return this.props.items;
        } else if (this.props.options != null) {
            return this.props.options.items;
        }

        return null;
    };

    getValueField = (): string => {
        if (this.props.options != null && this.props.options.valueField != null) {
            return this.props.options.valueField;
        }

        return 'value';
    };

    getDisplayField = (): string => {
        if (this.props.options != null && this.props.options.displayField != null) {
            return this.props.options.displayField;
        }

        return 'text';
    };

    handleOnRadioGroupChange = (e) => {
        let i = e.target.id;
        let n = i;

        if (typeof i === 'string') {
            n = parseInt(i, 10);
        }

        let val;

        if (!isNaN(n)) {
            const items = this.getItems();

            if (items != null) {
                val = items[n];
            }
        }

        if (val != null) {
            //val = val.value;
            val = val[this.getValueField()];
        }

        this.setState({ value: val });

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(val);
        }
    };

    handleOnClickLabelRG = (e) => {
        let i = e.target.htmlFor;
        let n = i;

        if (typeof i === 'string') {
            n = parseInt(i, 10);
        }

        let val;

        if (!isNaN(n)) {
            const items = this.getItems();

            if (items != null) {
                val = items[n];
            }
        }

        if (val != null) {
            //val = val.value;
            val = val[this.getValueField()];
        }

        if (val != null) {
            if (val !== this.state.value) {
                this.setState({ value: val });

                if (typeof this.props.onChange === 'function') {
                    this.props.onChange(val);
                }
            }
        }
    };

    render() {
        const { options } = this.props;
        const title = this.props.title != null ? this.props.title : (options && options.title) || '';
        const items = this.getItems();
        const useInitialValue = options && options.useInitialValue;
        //let classNew = "";
        //if (options != null && options.addClass != null) {
        //    classNew = options.addClass;
        //}

        let layout: RadioGroupFieldLayoutType = this.props.layout || 'horizontal';

        if (options != null && options.layout != null) {
            layout = options.layout;
        }

        let elements: React.JSX.Element[];

        if (items != null) {
            let radioGroupName = this.state.radioGroupName;

            if (options != null && options.name != null) {
                radioGroupName = options.name;
            }

            let commonElementClass = '';

            if (layout === 'vertical') {
                commonElementClass = 'block';
            }

            let displayField = this.getDisplayField();
            let valueField = this.getValueField();

            elements = _.map(items, (item, index) => {
                const itemValue = item[valueField];
                const itemText = item[displayField];

                let id = index.toString();

                //LL: 18.12.19:
                let checked = false;

                if (useInitialValue) {
                    // new
                    checked = compareObjects(itemValue, this.props.value);
                } else {
                    checked = compareObjects(itemValue, this.state.value);
                }

                //LL; see comment in gantt.tsx about slyder (input range) value and React
                //  defaultChecked={ this.state.value }   checked={ checked }

                //LL: <span> is convenient for Horiz Layout, <div> - for Vert

                //LL:  htmlFor ???
                //  https://stackoverflow.com/questions/29161330/react-js-ignores-labels-for-attribute

                //LL: 30.10.19: only for vertical
                let content;

                if (layout === 'vertical') {
                    content = item.content; //LL:  null or react element
                }

                //LL: 11.12.19:
                let disabled = this.props.disabled;

                if (item.disabled != null) {
                    disabled = item.disabled;
                }

                //LL: 23.12.19:
                let labelStyle: React.CSSProperties = {};

                if (!checked) {
                    labelStyle.fontWeight = 'normal'; //  600 -> 400
                }

                let elemStyle: React.CSSProperties = {
                    whiteSpace: 'nowrap'
                };

                let elementClass = commonElementClass;

                if (item.className != null) {
                    elementClass += ' ' + item.className;
                }

                return (
                    <span key={'span_' + itemValue} className={elementClass} style={elemStyle}>
                        <input
                            type="radio"
                            disabled={disabled}
                            id={id}
                            name={radioGroupName}
                            defaultChecked={checked}
                            onChange={this.handleOnRadioGroupChange}
                        />

                        <label
                            htmlFor={id}
                            id={'lab_' + id}
                            style={labelStyle}
                            onClick={disabled !== true ? this.handleOnClickLabelRG : undefined}
                        >
                            {itemText}
                        </label>

                        {content}
                    </span>
                );

                //LL: bad:
                //    input is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.
            });
        }

        //LL: set new key each time, otherwise React does not apply changes of input-radio, defaultCheck does not help
        ID++;

        const style: React.CSSProperties = {};

        if (options != null && options.width != null) {
            style.width = getCSSWidth(options.width);
        }

        //LL: 20.04.20
        if (layout === 'horizontal') {
            //styleRG.whiteSpace = "nowrap";
            // no  styleRG.textOverflow = "ellipsis";

            //     horizontalOverflow?: HorizontalOverflowType;  // 'hidden' | 'wrap'
            let horizontalOverflow = 'wrap'; //LL: is default, so not to hide by chance

            if (options != null && options.horizontalOverflow != null) {
                horizontalOverflow = options.horizontalOverflow;
            }

            if (horizontalOverflow === 'hidden') {
                //LL: in this case developer should set sufficient width of parent
                //styleRG.overflowX = "hidden";
                style.overflow = 'hidden';
                style.whiteSpace = 'nowrap';
            } else if (horizontalOverflow === 'wrap') {
                //styleRG.whiteSpace = "normal";  // default
            }
        }

        return (
            <div className="radiogroup-field" style={style} id={'rg_' + ID} key={'rg_' + ID} title={title}>
                {elements}
            </div>
        );
    }
}
